<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.OPTIONS.SELECTED"
    :handler="
      async () => {
        await $nextTick();
        await $nextTick();
        await $nextTick();
        $stores.services?.state?.transactionInitiation?.operation?.id ==
          'withdraw' && $refs.modal.show();
      }
    "
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.CLOSE_OPERATION_INITIATION"
    :handler="() => $refs.modal.hide()"
  />
  <DialogComponent
    ref="modal"
    type="bottomsheet"
    hideCloseButton
    @closed="
      ({ source }) =>
        source !== 'external' &&
        $bus.emit($constants.EVENTS.SERVICES.CLOSE_SERVICE_INITIATION)
    "
  >
    <div class="flex flex-col gap-6">
      <form
        class="w-full grid grid-cols-12 gap-4"
        v-bus:EVENTS.SERVICES.INITIATION.SUBMIT_FORM.submit.prevent
      >
        <!-- bookmaker id -->
        <div
          v-if="!$stores.services.state.transactionInitiation.bookmakerIdToUse"
          class="col-span-12"
        >
          <div class="relative">
            <input
              v-model="$stores.services.state.transactionInitiation.bookmakerId"
              type="number"
              required
              placeholder=" "
              :id="'bookmakerId-' + $id"
              class="peer inputComponent"
            />
            <label
              :for="'bookmakerId-' + $id"
              class="absolute left-4 top-4 text-gray-400 transition-all peer-focus:-top-2.5 peer-focus:left-3 peer-focus:text-xs peer-focus:text-primary peer-placeholder-shown:top-4 peer-placeholder-shown:left-4 peer-placeholder-shown:text-base peer-not-placeholder-shown:-top-2.5 peer-not-placeholder-shown:left-3 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:text-primary bg-white px-1 pointer-events-none"
            >
              Votre Id
              {{ $stores.services.state?.transactionInitiation?.service?.name }}
            </label>
          </div>
        </div>

        <!-- amount -->
        <div class="col-span-12">
          <div class="relative">
            <input
              v-model="
                $stores.services.state.transactionInitiation.senderAmount
              "
              type="number"
              required
              placeholder=" "
              :id="'amount-' + $id"
              class="peer inputComponent pr-20"
              :min="minWithdrawAmount"
              @input="validateWithdrawAmount"
            />
            <label
              :for="'amount-' + $id"
              class="absolute left-4 top-4 text-gray-400 transition-all peer-focus:-top-2.5 peer-focus:left-3 peer-focus:text-xs peer-focus:text-primary peer-placeholder-shown:top-4 peer-placeholder-shown:left-4 peer-placeholder-shown:text-base peer-not-placeholder-shown:-top-2.5 peer-not-placeholder-shown:left-3 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:text-primary bg-white px-1 pointer-events-none"
            >
              Montant (minimum: {{ minWithdrawAmount }} CFA)
            </label>
            <div
              class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 font-medium"
            >
              CFA
            </div>
            <div
              v-if="withdrawAmountError"
              class="text-red-500 text-xs mt-1 pl-4"
            >
              {{ withdrawAmountError }}
            </div>
          </div>
        </div>

        <!-- phone -->
        <div class="col-span-12 mt-2">
          <div class="relative">
            <input
              v-model="$stores.services.state.transactionInitiation.phoneNumber"
              required
              type="text"
              inputmode="numeric"
              pattern="[0-9]{8,}"
              :placeholder="`Ex: ${getPhoneExample($stores.user.state.current?.countryCode)}`"
              :id="'phone-' + $id"
              class="peer inputComponent pr-24"
              ref="phoneNumberInput"
              @input="
                if (!$stores.services.state.transactionInitiation.phoneNumber) {
                  $refs.phoneNumberInput.setCustomValidity('');
                }
              "
            />
            <label
              :for="'phone-' + $id"
              class="absolute left-4 top-4 text-gray-400 transition-all peer-focus:-top-2.5 peer-focus:left-3 peer-focus:text-xs peer-focus:text-primary peer-placeholder-shown:top-4 peer-placeholder-shown:left-4 peer-placeholder-shown:text-base peer-not-placeholder-shown:-top-2.5 peer-not-placeholder-shown:left-3 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:text-primary bg-white px-1 pointer-events-none"
            >
              Numéro Mobile Money
            </label>
            <div
              class="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-2"
            >
              <PhoneDetail
                :phoneNumber="
                  $stores.services.state.transactionInitiation.phoneNumber
                "
                :countryCode="$stores.user.state.current?.countryCode"
                @loading="
                  (data) => {
                    $refs.phoneNumberInput.setCustomValidity('chargement');
                    $stores.services.state.transactionInitiation.phoneOperator =
                      '';
                  }
                "
                @resolved="
                  (data) => {
                    $refs.phoneNumberInput.setCustomValidity('');
                    $stores.services.state.transactionInitiation.phoneOperator =
                      data.carrier;
                  }
                "
                @error="
                  (data) => {
                    $stores.services.state.transactionInitiation.phoneOperator =
                      '';
                    $refs.phoneNumberInput.setCustomValidity(
                      `Erreur du numéro: ${data.error}`
                    );
                  }
                "
                v-slot="{ carrier, logoUrl }"
              >
                <img
                  v-if="logoUrl"
                  :src="logoUrl"
                  class="w-8 h-5 object-contain"
                  alt=""
                />
                <span v-else class="text-xs text-gray-500">{{ carrier }}</span>
              </PhoneDetail>
            </div>
          </div>
        </div>

        <!-- withdrawal code -->
        <div class="col-span-12">
          <div class="relative">
            <input
              v-model="
                $stores.services.state.transactionInitiation.withdrawalCode
              "
              type="text"
              required
              placeholder=" "
              :id="'code-' + $id"
              class="peer inputComponent"
            />
            <label
              :for="'code-' + $id"
              class="absolute left-4 top-4 text-gray-400 transition-all peer-focus:-top-2.5 peer-focus:left-3 peer-focus:text-xs peer-focus:text-primary peer-placeholder-shown:top-4 peer-placeholder-shown:left-4 peer-placeholder-shown:text-base peer-not-placeholder-shown:-top-2.5 peer-not-placeholder-shown:left-3 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:text-primary bg-white px-1 pointer-events-none"
            >
              Code de retrait
              {{ $stores.services.state?.transactionInitiation?.service?.name }}
            </label>
          </div>
        </div>

        <!-- withdrawal address -->
        <div
          class="col-span-12 bg-gray-900 rounded-xl p-4 text-gray-300 font-black"
        >
          <div class="font-medium text-sm mb-2 uppercase">Adresse de retrait</div>
          <pre class="whitespace-pre-wrap text-xs">{{
            $stores.appData.state.data.addresses[
              $stores.user.state.current?.countryCode
            ]?.[
              $constants.SERVICES.BOOKMAKER_WITHDRAWAL_ADDRESS_KEYS?.[
                $stores.services?.state?.transactionInitiation?.service?.id
              ]
            ] || 'Non disponible pour le moment'
          }}</pre>
        </div>

        <!-- info box -->
        <div
          v-if="
            $stores.services?.state?.transactionInitiation?.bookmakerIdToUse
          "
          class="col-span-12 bg-gray-900 rounded-xl p-4 mx-1 text-gray-300 font-medium text-xs flex gap-2 items-center"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#07D79D"
            stroke-width="2"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4M12 8h.01" />
          </svg>
          <div>
            Nous allons retirer depuis le compte
            <span class="text-[#07D79D]">
              <BookmakerAccountDetail
                :canChange="true"
                :bookmaker="
                  $stores.services?.state?.transactionInitiation?.service?.id
                "
                :bookmakerId="
                  $stores.services?.state?.transactionInitiation
                    ?.bookmakerIdToUse
                "
              />
            </span>
          </div>
        </div>

        <!-- video link -->
        <div class="col-span-12" v-if="tutorialVideoUrl">
          <div
            class="text-sm font-bold text-red-500 flex items-center justify-end gap-2 cursor-pointer"
            @click="$bus.emit($constants.EVENTS.VIDEO.PLAY, tutorialVideoUrl)"
          >
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
              />
            </svg>
            Voir comment faire un retrait
          </div>
        </div>

        <!-- summary -->
        <div class="col-span-12">
          <ShortSummary />
        </div>

        <!-- submit button -->
        <div class="col-span-12">
          <button
            :disabled="
              $stores.services?.state?.transactionInitiationFees?.loadingFees ||
              $stores.services?.state?.initiatingPayment ||
              !!withdrawAmountError
            "
            :class="{
              'opacity-50':
                $stores.services?.state?.transactionInitiationFees
                  ?.loadingFees ||
                $stores.services?.state?.initiatingPayment ||
                !!withdrawAmountError
            }"
            class="w-full py-4 bg-primary text-white rounded-xl font-semibold text-base shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2"
            type="submit"
          >
            <span
              v-if="
                !$stores.services?.state?.transactionInitiationFees
                  ?.loadingFees && !$stores.services?.state?.initiatingPayment
              "
            >
              Retirer
              {{
                $stores.services?.state?.transactionInitiationFees?.srcAmount ||
                0
              }}
              CFA
            </span>
            <span v-else class="flex items-center gap-2">
              <svg
                class="animate-spin"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="3"
                  class="opacity-25"
                />
                <path
                  fill="currentColor"
                  class="opacity-75"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              Traitement...
            </span>
          </button>

          <button
            v-if="$stores.services?.state?.initiatingPayment"
            type="button"
            @click="
              $bus.emit($constants.EVENTS.SERVICES.CLOSE_SERVICE_INITIATION)
            "
            class="w-full py-3 mt-2 text-red-600 font-bold border-2 border-red-100 rounded-xl hover:bg-red-50 transition-colors flex items-center justify-center gap-2"
          >
            Annuler la transaction
          </button>
        </div>
      </form>
    </div>
  </DialogComponent>
</template>

<script setup>
import { getCurrentInstance } from 'vue';
import { ref, computed } from 'vue';
import {
  getMinAmount,
  getEffectiveMaxLimit
} from '@features/appData/limitsHelper';
import { resolveVideoLink } from '@features/appData/appDataHelper';
import { getPhoneExample } from '@features/shared/countries';

const { proxy } = getCurrentInstance();

const { $stores, $id } = proxy;

const withdrawAmountError = ref(null);

const minWithdrawAmount = computed(() => {
  const serviceId = $stores.services?.state?.transactionInitiation?.service?.id;
  const countryCode = $stores.user.state.current?.countryCode;
  if (!countryCode) return 0;
  return getMinAmount(countryCode, 'withdraw', serviceId);
});

const maxWithdrawAmount = computed(() => {
  const serviceId = $stores.services?.state?.transactionInitiation?.service?.id;
  const countryCode = $stores.user.state.current?.countryCode;
  if (!countryCode) return Infinity;
  return getEffectiveMaxLimit(countryCode, 'withdraw', serviceId);
});

const tutorialVideoUrl = computed(() =>
  resolveVideoLink($stores.appData?.state?.data, {
    serviceId: $stores.services?.state?.transactionInitiation?.service?.id,
    operation: $stores.services?.state?.transactionInitiation?.operation?.id,
    countryCode: $stores.user.state.current?.countryCode
  })
);

function validateWithdrawAmount() {
  const amount = parseFloat(
    $stores.services.state.transactionInitiation.senderAmount
  );
  const min = minWithdrawAmount.value;
  const max = maxWithdrawAmount.value;

  if (!amount || amount < min) {
    withdrawAmountError.value = `Le montant minimum de retrait est de ${min} CFA`;
  } else if (max !== Infinity && amount > max) {
    withdrawAmountError.value = `Le montant maximum de retrait est de ${max} CFA`;
  } else {
    withdrawAmountError.value = null;
  }
}

validateWithdrawAmount();
</script>
